// src/services/listasTrabajoService.js

import {
    listasTrabajoObtenerJWT,
    listasTrabajoObtenerUnaJWT,
    listasTrabajoCrearJWT,
    listasTrabajoActualizarJWT,
    listasTrabajoEliminarJWT,
    listasTrabajoAgregarExpedientesJWT,
    listasTrabajoEliminarExpedientesJWT,
    listasTrabajoMarcarVistoJWT,
    listasTrabajoToggleFavoritaJWT,
    listasTrabajoActualizarNotasJWT,
} from '../api/endpoints';

const listasTrabajoService = {
    async obtenerListas(tipoExpediente = null) {
        try {
            const data = await listasTrabajoObtenerJWT(tipoExpediente);
            return data.listas || [];
        } catch (error) {
            console.error('Error al obtener listas:', error);
            throw error;
        }
    },

    async obtenerLista(idLista, page, pageSize) {
        try {
            const data = await listasTrabajoObtenerUnaJWT(idLista, page, pageSize);
            return data;
        } catch (error) {
            console.error('Error al obtener lista:', error);
            throw error;
        }
    },

    async crearLista(datos) {
        try {
            const data = await listasTrabajoCrearJWT(datos);
            return data;
        } catch (error) {
            console.error('Error al crear lista:', error);
            throw error;
        }
    },

    async actualizarLista(idLista, datos) {
        try {
            return await listasTrabajoActualizarJWT(idLista, datos);
        } catch (error) {
            console.error('Error al actualizar lista:', error);
            throw error;
        }
    },

    async eliminarLista(idLista) {
        try {
            return await listasTrabajoEliminarJWT(idLista);
        } catch (error) {
            console.error('Error al eliminar lista:', error);
            throw error;
        }
    },

    async agregarExpedientes(idLista, expedientesIds) {
        try {
            return await listasTrabajoAgregarExpedientesJWT(idLista, expedientesIds);
        } catch (error) {
            console.error('Error al agregar expedientes:', error);
            throw error;
        }
    },

    async eliminarExpedientes(idLista, expedientesIds) {
        try {
            return await listasTrabajoEliminarExpedientesJWT(idLista, expedientesIds);
        } catch (error) {
            console.error('Error al eliminar expedientes:', error);
            throw error;
        }
    },

    async marcarComoVisto(idLista, expedienteId) {
        try {
            return await listasTrabajoMarcarVistoJWT(idLista, expedienteId);
        } catch (error) {
            console.error('Error al marcar como visto:', error);
            throw error;
        }
    },

    async toggleFavorita(idLista, favorita) {
        return listasTrabajoToggleFavoritaJWT(idLista, favorita);
    },

    async actualizarNotas(idLista, expedienteId, notas) {
        try {
            return await listasTrabajoActualizarNotasJWT(idLista, expedienteId, notas);
        } catch (error) {
            console.error('Error al actualizar notas:', error);
            throw error;
        }
    }
};

export default listasTrabajoService;
